import React from 'react';
import { useI18n } from '../hooks/useI18n';
import { useAuth } from '../hooks/useAuth';
import { ServiceCard } from '../components/services/ServiceCard';
import { ServiceItem } from '../types/cabinet.types';

// Import icons as React components
import OverweightIcon from '../../assets/image/overweight.svg?react';
import AnalysisIcon from '../../assets/image/analysis.svg?react';
import FileTextIcon from '../../assets/image/file-text.svg?react';
import PhoneCallIcon from '../../assets/image/phone-call.svg?react';
import FilePlusIcon from '../../assets/image/file-plus.svg?react';
import HeartHandshakeIcon from '../../assets/image/heart-handshake.svg?react';
import ziolo24Logo from '../../assets/image/ziolo24-logo.png';

export const ServicesPage: React.FC = () => {
  const { t, lang } = useI18n();
  const { user } = useAuth();
  const currentLang = lang || 'pl';

  // Define services list matching the Figma order and design
  const services: ServiceItem[] = [
    {
      id: 'recepta',
      title: t('cs_recepta'),
      description: t('cs_recepta_d'),
      icon: <FileTextIcon />,
      isGlp1: false
    },
    {
      id: 'check',
      title: t('cs_check'),
      description: t('cs_check_d'),
      icon: <AnalysisIcon />,
      isGlp1: false
    },
    {
      id: 'anty',
      title: t('cs_anty'),
      description: t('cs_anty_d'),
      icon: <FilePlusIcon />,
      isGlp1: false
    },
    {
      id: 'l4',
      title: t('cs_l4'),
      description: t('cs_l4_d'),
      icon: <HeartHandshakeIcon />,
      isGlp1: false
    },
    {
      id: 'tele',
      title: t('cs_tele'),
      description: t('cs_tele_d'),
      icon: <PhoneCallIcon />,
      isGlp1: false
    },
    ...(currentLang === 'pl' ? [{
      id: 'ziolo24',
      title: 'Terapia konopiami medycznymi',
      description: 'Wizyta stacjonarna w Ziolo24 w całej Polsce — pierwsza wizyta <strong>od 149 zł</strong>. <strong>−10% z kodem TABLETKA24</strong>',
      icon: <img src={ziolo24Logo} alt="Ziolo24" />,
      isGlp1: false
    }] : [])
  ];

  // Show all services to match Figma (temporarily or permanently removed persona A filter)
  const availableServices = services;

  const handleServiceClick = (id: string) => {
      if (id === 'ziolo24') {
          window.location.href = 'https://ziolo24.pl/?utm_source=tabletka24&utm_medium=konto&utm_campaign=crosssell';
          return;
      }

      // Typically we'd navigate to the respective product page
      // In a real WP environment, these might be hardcoded URLs or fetched from an API
      if (typeof window !== 'undefined' && window.cabinetVars?.siteUrl) {
          // Placeholder redirect logic
          // Use current React language instead of initial page load language
          const currentLang = lang || 'pl';
          
          const slugMap: Record<string, Record<string, string>> = {
              'pl': {
                  'glp1': '/usluga/leczenie-otylosci-online/',
                  'recepta': '/usluga/e-konsultacja/',
                  'anty': '/usluga/antykoncepcja/',
                  'l4': '/usluga/l4/',
                  'tele': '/usluga/teleporada-direct/',
                  'check': '/usluga/lab-pakiet-ogolny/'
              },
              'uk': {
                  'glp1': '/uk/usluga/likuvannya-zajvoyi-vagy/', // ЗАМІНІТЬ НА РЕАЛЬНІ УКР ЛІНКИ
                  'recepta': '/uk/usluga/elektronnyj-reczept/',
                  'anty': '/uk/usluga/e-reczept-na-kontraczepcziyu-onlajn/',
                  'l4': '/uk/usluga/elektronna-l4/',
                  'tele': '/uk/usluga/teleporada-osnovna/',
                  'check': '/uk/usluga/lab-zagalnyj-paket/'
              },
              'ru': {
                  'glp1': '/ru/usluga/lechenie-lishnego-vesa/', // ЗАМІНІТЬ НА РЕАЛЬНІ РОС ЛІНКИ
                  'recepta': '/ru/usluga/elektronnyj-reczept-ru/',
                  'anty': '/ru/usluga/kontraczeptivy-po-elektronnomu-reczeptu/',
                  'l4': '/ru/usluga/elektronnaya-l4/',
                  'tele': '/ru/usluga/telefonnaya-konsultacziya-osnovnaya/',
                  'check': '/uk/usluga/lab-zagalnyj-paket/'
              }
          };
          
          const slug = slugMap[currentLang]?.[id] || slugMap['pl'][id] || '/';
          window.location.href = `${window.cabinetVars.siteUrl}${slug}`;
      }
  };

  return (
    <div style={{ paddingTop: '20px' }}>
      <h1 className="cab-page-title" style={{ textAlign: 'left', marginBottom: '24px', color: '#2F116A', fontSize: '24px', fontWeight: '800', lineHeight: '1.2' }}>
        {t('uslugi_title_a')}
      </h1>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {availableServices.map(service => (
          <ServiceCard 
            key={service.id} 
            service={service} 
            onClick={() => handleServiceClick(service.id)} 
          />
        ))}
      </div>
    </div>
  );
};
